import { lazy } from 'react';
import { Route } from 'react-router-dom';

const DashboardPage = lazy(() =>
  import('./pages/DashboardPage').then(m => ({ default: m.DashboardPage }))
);

export const dashboardRoutes = <Route index element={<DashboardPage />} />;
